// Role Selection (Task 13.1).
//
// Presented to a signed-in User who has no assigned role (Req 1.6, 2.1). It
// offers exactly two selectable options — Restaurant and NGO — and never
// surfaces Admin or Super Admin (Req 2.2).

import { Card } from "../../components/primitives";

export type SelectableRole = "Restaurant" | "NGO";

export function RoleSelection({
  onSelect,
}: {
  onSelect: (role: SelectableRole) => void;
}): JSX.Element {
  return (
    <div className="sb-main">
      <Card title="Choose your role">
        <p className="sb-muted">
          Select how you'll use ShareBite. You can register as a restaurant
          donating surplus food, or an NGO collecting it.
        </p>
        <div className="sb-grid sb-grid--2">
          <button
            type="button"
            className="sb-btn"
            onClick={() => onSelect("Restaurant")}
          >
            Restaurant
          </button>
          <button
            type="button"
            className="sb-btn"
            onClick={() => onSelect("NGO")}
          >
            NGO
          </button>
        </div>
      </Card>
    </div>
  );
}
